// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1___4c30c572d8d75133f53","cls2":"ResearcherList-cls2___62640b1d72295e0d5cf ResearcherList-cls1___4c30c572d8d75133f53"};